import React, { useContext } from "react";
import { CurrentContext, SetterContext } from "../App";
import ConfigOutsideColorRadioButton from "./elements/ConfigOutsideColorRadioButton";

function OutsideColorButtonGroup( props: {
	name: string;
	elements: {
		name: string;
		price: number;
		colorCode: string;
		path: string;
	}[],
	heading?: string,
	featureList?: any[],
} ) {
	const Current = useContext( CurrentContext );
	const createSetter = useContext( SetterContext );

	return <div className="flex category-container" id="fahrzeug-laenge">
		{props.heading && <div className="flex category-title">{props.heading}</div>}
		<div className="flex button-area" id="fahrzeug-laenge-buttons">
			{props.elements.map(
				(v) =>
					<ConfigOutsideColorRadioButton
						value={v}
						key={v.name}
						name={props.name}
						selected={Current[props.name] === v.name}
						callback={createSetter(props.name)}
					/>,
			)}


		</div>
		<p className={"color-info"}>Weitere Farbauswahlen sind auch möglich</p>
		{props.featureList && <>
			<div className="flex vertical-line"></div>
			<div className="flex paket-content" id="fahrzeug-paket-inhalt">
				{props.featureList[props.elements.indexOf(Current[props.name])]}
			</div>
		</>}
	</div>;
}

export default OutsideColorButtonGroup;
